/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  SendSequenceStepTestEmailMutationRequest,
  SendSequenceStepTestEmailMutationResponse,
  SendSequenceStepTestEmailPathParams,
  SendSequenceStepTestEmail400,
  SendSequenceStepTestEmail404,
} from '../types/SendSequenceStepTestEmail'

function getSendSequenceStepTestEmailUrl({
  bison_step_id,
}: {
  bison_step_id: SendSequenceStepTestEmailPathParams['bison_step_id']
}) {
  const res = {
    method: 'POST',
    url: `/api/v1/emailbison/sequence-steps/${bison_step_id}/test-email/` as const,
  }
  return res
}

/**
 * @description Send a test email for a single sequence step through EmailBison.
 * Two modes:
 * 1. **Default (random contact):** No rendered content in the payload.
 * Calls `/api/campaigns/sequence-steps/<id>/test-email` so EmailBison
 * renders the step template through the same pipeline as a real send and
 * fills variables from a random campaign lead.
 * 2. **Per-contact preview:** Caller supplies `rendered_subject` and
 * `rendered_body` (variables already substituted for a specific lead).
 * Routes through `/api/replies/new` so we send the literal content the
 * reviewer is staring at, since EmailBison's test-email endpoint does
 * not accept a lead_id and would otherwise pick a random one.
 * Endpoint:
 * - POST /api/emailbison/sequence-steps/<bison_step_id>/test-email/
 * @summary Send a test email for a sequence step
 * {@link /api/v1/emailbison/sequence-steps/:bison_step_id/test-email/}
 */
export async function sendSequenceStepTestEmail(
  {
    bison_step_id,
  }: { bison_step_id: SendSequenceStepTestEmailPathParams['bison_step_id'] },
  data: SendSequenceStepTestEmailMutationRequest,
  config: Partial<RequestConfig<SendSequenceStepTestEmailMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    SendSequenceStepTestEmailMutationResponse,
    ResponseErrorConfig<
      SendSequenceStepTestEmail400 | SendSequenceStepTestEmail404
    >,
    SendSequenceStepTestEmailMutationRequest
  >({
    method: 'POST',
    url: getSendSequenceStepTestEmailUrl({ bison_step_id }).url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
